import React, { useEffect, useState } from "react";
import RecommendedTrainerMoreDetails from "./RecommendedTrainerMoreDetails";
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const RecommendedTrainerDetails = () => {
    const [loginId, setLoginId] = useState('');

    useEffect(() => {
        let id = localStorage.getItem("userId");
        setLoginId(id);
    }, []);

    return (
        <>
            {loginId !== '' ? (
                <>
                    <IdleTimeOutHandler />
                    <RecommendedTrainerMoreDetails />
                </>
            ) : (
                <RecommendedTrainerMoreDetails />
            )}
        </>
    )
}

export default RecommendedTrainerDetails;
